import { render, staticRenderFns } from "./OtherPaymentMethods.vue?vue&type=template&id=57883a6a"
import script from "./OtherPaymentMethods.vue?vue&type=script&lang=js"
export * from "./OtherPaymentMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports